module.exports = __webpack_public_path__ + "static/media/HCMM802.a94b8bb2.jpg";